/*
|--------------------------------------------------------------------------
|
| 这些组件暴露给使用方
|
|--------------------------------------------------------------------------
*/
import FinD, { TestExport } from '../components';
const toExport = { ...FinD, TestExport };
export default toExport;
